export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/comment/icon-best-white-7a3436710a62e08d4aab8153f065b8f7.svg";